/*
 * Ouate Paris Belgique - Débarbouillettes offertes dès 45 €
 * Adds "Mes Débarbouillettes Zéro Déchet" to the cart as a gift line
 * (property _ouate_gift) when eligible items reach the threshold, and removes
 * it when the cart drops below. The price is set to 0 by the automatic
 * discount "Débarbouillettes offertes dès 45 €" (Shopify admin > Réductions).
 * Safety: if the gift line is not free (discount off or expired), it is
 * removed straight away so the customer is never charged for it.
 * Config comes from layout/theme.liquid: window.OuateGift.
 */
(() => {
  const cfg = window.OuateGift;
  if (!cfg || !cfg.enabled || !cfg.variantId) return;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const PROP = '_ouate_gift';
  const threshold = Number(cfg.threshold) || 4500; // in cents
  let busy = false;
  let again = false;
  let disabled = false;
  let timer = null;

  const isGiftVariant = (item) => item.variant_id === Number(cfg.variantId);
  const isGiftLine = (item) => isGiftVariant(item) && item.properties && item.properties[PROP];

  // Eligible amount = every line except the washcloths (gift or paid),
  // after line-level discounts. Mirrors the discount's eligible collection.
  const eligibleTotal = (cart) =>
    cart.items.filter((item) => !isGiftVariant(item)).reduce((sum, item) => sum + item.final_line_price, 0);

  const sectionIds = () => {
    const ids = [];
    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      cartItems.getSectionsToRender().forEach((s) => s.section && ids.push(s.section));
    } else {
      ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'].forEach((id) => {
        if (document.getElementById(id)) ids.push(id);
      });
    }
    return [...new Set(ids)].filter((id) => id !== 'cart-live-region-text').slice(0, 5);
  };

  const getCart = () =>
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());

  const post = async (path, body) => {
    const response = await fetch(`${root}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error(`${path} ${response.status}`);
    return response.json();
  };

  const refreshUI = (cart, sections) => {
    const state = Object.assign({}, cart, { sections: sections || {} });
    const canPublish = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
    if (canPublish && document.querySelector('cart-items')) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ouate-gift', cart: state });
      return;
    }
    // No cart rendered yet (drawer not loaded): refresh what exists, e.g. the cart count bubble.
    Object.entries(sections || {}).forEach(([id, html]) => {
      const target = document.getElementById(id);
      if (!target || !html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  };

  const sync = async () => {
    if (disabled) return;
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    try {
      const cart = await getCart();
      const giftLines = cart.items.filter(isGiftLine);
      const eligible = eligibleTotal(cart) >= threshold;
      const sections = sectionIds();
      const sections_url = window.location.pathname;

      if (eligible && giftLines.length === 0) {
        const added = await post('cart/add.js', {
          items: [{ id: Number(cfg.variantId), quantity: 1, properties: { [PROP]: '1' } }],
          sections,
          sections_url
        });
        const after = await getCart();
        const giftLine = after.items.find(isGiftLine);
        if (giftLine && giftLine.final_line_price > 0) {
          // Discount not applied: never charge the gift. Remove it and stop for this page view.
          disabled = true;
          const removed = await post('cart/change.js', { id: giftLine.key, quantity: 0, sections, sections_url });
          refreshUI(removed, removed.sections);
          return;
        }
        refreshUI(after, added.sections);
        document.dispatchEvent(new CustomEvent('ouate:gift-added', { detail: { cart: after } }));
      } else if (eligible && (giftLines.length > 1 || giftLines[0].quantity !== 1)) {
        // Keep exactly one gift.
        const updates = {};
        giftLines.forEach((line, index) => {
          updates[line.key] = index === 0 ? 1 : 0;
        });
        const updated = await post('cart/update.js', { updates, sections, sections_url });
        refreshUI(updated, updated.sections);
      } else if (!eligible && giftLines.length > 0) {
        const updates = {};
        giftLines.forEach((line) => {
          updates[line.key] = 0;
        });
        const updated = await post('cart/update.js', { updates, sections, sections_url });
        refreshUI(updated, updated.sections);
        document.dispatchEvent(new CustomEvent('ouate:gift-removed', { detail: { cart: updated } }));
      }
    } catch (error) {
      console.warn('[Ouate gift]', error);
    } finally {
      busy = false;
      if (again) {
        again = false;
        schedule();
      }
    }
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'ouate-gift') return;
      schedule();
    });
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) schedule();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
